import React from 'react'
import "@fontsource/catamaran"
import "@fontsource/catamaran/700.css"

import "@fontsource/lora"
import "@fontsource/lora/400-italic.css"
import "@fontsource/lora/700.css"

// import { useStaticQuery, graphql } from "gatsby"

import Header from './Header'
import Footer from './Footer'
import BrandFooterRegion from './BrandFooterRegion'
import MainNavigation from '../components/Navigation/Navigation'
import '../assets/all.scss'

function TemplateWrapper({ children, location }) {
  return (
    <>
      <Header />
      <div className="content-area">
        <MainNavigation location={location} />
        <div
          className="pos-relative z-index-bottom"
          role="main"
        >
          <main
            id="main"
          >
            {children}
          </main>
        </div>
        <BrandFooterRegion />
      </div>
      <Footer />
    </>
  )
}

export default TemplateWrapper
